/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/ApprovalMatrixDrawer.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Approval Matrix
 *
 * PURPOSE:
 * Approval Matrix Create / Edit Dialog
 *
 * ARCHITECTURE
 * - Bootstrap/AdminLTE
 * - Stateless Component
 * - Hosts ApprovalMatrixForm
 * - No Business Logic
 ******************************************************************************/

import React from "react";

import ApprovalMatrixForm from "./ApprovalMatrixForm";

export default function ApprovalMatrixDrawer({

    open,

    mode = "create",

    approvalMatrix = null,

    formData,

    errors = {},

    loading = false,

    saving = false,

    workflows = [],

    workflowTypes = [],

    approvalLevels = [],

    departments = [],

    locations = [],

    expensePolicies = [],

    expenseCategories = [],

    expenseTypes = [],

    currencies = [],

    designations = [],

    employees = [],

    onChange,

    onClose,

    onSubmit,

}) {

    if (!open) {

        return null;

    }

    const title =

        mode === "edit"

            ? "Edit Approval Matrix"

            : "Create Approval Matrix";

    return (

        <div
            className="modal fade show"
            style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.50)",
            }}
        >

            <div
                className="modal-dialog modal-xl modal-dialog-scrollable"
            >

                <div className="modal-content">

                    {/* ------------------------------------------------ */}
                    {/* HEADER */}
                    {/* ------------------------------------------------ */}

                    <div className="modal-header">

                        <h5 className="modal-title">

                            {title}

                        </h5>

                        <button

                            type="button"

                            className="btn-close"

                            onClick={onClose}

                        />

                    </div>

                    {/* ------------------------------------------------ */}
                    {/* BODY */}
                    {/* ------------------------------------------------ */}

                    <div className="modal-body">

                        <ApprovalMatrixForm

                            formData={formData}

                            errors={errors}

                            loading={loading}

                            saving={saving}

                            workflows={workflows}

                            workflowTypes={workflowTypes}

                            approvalLevels={approvalLevels}

                            departments={departments}

                            locations={locations}

                            expensePolicies={expensePolicies}

                            expenseCategories={expenseCategories}

                            expenseTypes={expenseTypes}

                            currencies={currencies}

                            designations={designations}

                            employees={employees}

                            onChange={onChange}

                            onSubmit={onSubmit}

                            onCancel={onClose}

                        />

                    </div>

                </div>

            </div>

        </div>

    );

}